import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Checkbox, Column, Row, Typography } from 'seagull';
import { serviceCostModel } from '~/models';
import styles from './AddServices.module.scss';
import { formatPrice } from './AddServices.utils';
import { AddServicesTestIds } from './AddServicesTestIds';
export const AddServicesServiceList = (param)=>{
    let { serviceTemplates, selectedServiceTemplateIds, onToggle, noNegativeMargin } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.serviceItemsWrapper, {
            [styles.noNegativeMargin]: noNegativeMargin
        }),
        children: [
            serviceTemplates.map((template)=>{
                const isSelected = selectedServiceTemplateIds.includes(template.id);
                const discountedPrice = serviceCostModel.finalPrice(template.cost, 1);
                return /*#__PURE__*/ _jsxs(Row, {
                    onClick: ()=>onToggle(template.id),
                    testId: AddServicesTestIds.ServiceItem(template.id),
                    className: styles.serviceItem,
                    children: [
                        /*#__PURE__*/ _jsx(Checkbox, {
                            bi: {
                                name: 'included_service',
                                data: {
                                    service_id: template.id
                                }
                            },
                            testId: AddServicesTestIds.ServiceCheckbox(template.id),
                            checked: isSelected
                        }),
                        /*#__PURE__*/ _jsxs(Column, {
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph1",
                                    children: template.name
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph2",
                                    skin: "secondary",
                                    testId: AddServicesTestIds.ServiceItemPrice(template.id),
                                    children: formatPrice(discountedPrice, template.cost.pricingType)
                                })
                            ]
                        })
                    ]
                }, template.id);
            }),
            serviceTemplates.length === 0 && /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                skin: "secondary",
                children: "No services found"
            })
        ]
    });
};
